import React from "react";
import { formatDateTime } from "../utils/FormatDateTime";

const ExpenseCard = ({ expense, onClick }) => {
    const isIncome = expense.type === "Income";
    const amountColor = isIncome ? "text-green-600" : "text-red-600";
    const amountIcon = isIncome ? "↗" : "↘";

    return (
        <div
            onClick={() => onClick(expense)}
            className="cursor-pointer border border-gray-200 rounded-lg p-3 hover:shadow-md transition-all duration-200 bg-gradient-to-br from-white to-gray-50 hover:from-gray-50 hover:to-gray-100"
        >
            <div className="flex flex-col gap-2">
                {/* Header Row */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-lg overflow-hidden">
                            {expense.commodity_image && (
                                <img
                                    src={expense.commodity_image}
                                    alt={expense.commodity_name}
                                    className="w-full h-full object-cover"
                                />
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-semibold text-sm text-gray-800 truncate">
                                {expense.category}
                            </h3>
                            <p className="text-xs text-gray-500 truncate">
                                {expense.subType || expense.sub_category}
                            </p>
                        </div>
                    </div>
                    <div className="text-right">
                        <p className="text-xs text-gray-500">
                            {formatDateTime(expense.date)}
                        </p>
                    </div>
                </div>

                {/* Amount Row */}
                <div className="flex items-center justify-between">
                    <div className="flex-1">
                        <p className="text-xs text-gray-600 truncate">
                            {expense.note || "No description"}
                        </p>
                    </div>
                    <div className="flex items-center gap-1">
                        <span className="text-sm">{amountIcon}</span>
                        <span className={`text-sm font-bold ${amountColor}`}>
                            ₹{expense.amountUpdated || expense.amount}
                        </span>
                    </div>
                </div>

                {/* Farm Info */}
                {expense.farm && expense.farm.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                        {expense.farm.slice(0, 2).map((farm, index) => (
                            <span
                                key={index}
                                className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
                            >
                                {farm.name}
                            </span>
                        ))}
                        {expense.farm.length > 2 && (
                            <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                                +{expense.farm.length - 2} more
                            </span>
                        )}
                    </div>
                )}

                {/* Bill Image Indicator */}
                {expense.bill && (
                    <div className="flex items-center gap-1 text-xs text-gray-500">
                        <span>📄</span>
                        <span>Bill attached</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExpenseCard;
